import CodeInput from './CodeInput'

export * from './CodeInput'

export default CodeInput
